import type {TextQuestion, SurveyHandler, SurveyError} from 'src/types/survey';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Answer'. Did you mean to use 'import Answer from "src/api-parsers/events"' instead?
import type {Answer} from 'src/api-parsers/events';
import type {AttributeMetaData} from 'src/types/writeback';

import * as React from 'react';

import {classify} from 'src/utils';

import Loading from 'src/components/lib/loading/loading';
import {NumberInputNew} from 'src/components/lib/number-input/number-input';

import css from './text.css';


const buttonClass = css.submitButton.split(' ')[0];

type TextSurveyProps = {
  data: TextQuestion;
  response?: Answer;
  handleNext: SurveyHandler;
  buttonColor: string;
  currentError: SurveyError;
  audienceVariables: {
    [key: string]: string | number | boolean | null | undefined;
  };
  atsFieldWritebackEnabled: boolean;
  fetching: boolean;
  writebackFieldAttributes: AttributeMetaData;
};

let textarea;

const TextSurveyQuestion = (
  props: TextSurveyProps,
): React.ReactElement<React.ComponentProps<'div'>> => {
  const {
    data,
    response,
    handleNext,
    buttonColor,
    currentError,
    audienceVariables,
    atsFieldWritebackEnabled,
    fetching,
    writebackFieldAttributes,
  } = props;

  const writebackPrefillEnabled =
    atsFieldWritebackEnabled &&
    data.writeback?.show_current_value &&
    data.writeback?.attribute_name;
  const writebackPrefill =
    writebackPrefillEnabled &&
    // @ts-expect-error - TS18048 - 'data.writeback' is possibly 'undefined'. | TS2538 - Type 'undefined' cannot be used as an index type.
    audienceVariables?.[data.writeback.attribute_name];
  const defaultValue = response?.moduleValue || writebackPrefill || '';

  const [answer, setAnswer] = React.useState(String(defaultValue));

  const maxFieldLength =
    data.writeback && writebackFieldAttributes?.max_field_length;
  const showHint =
    maxFieldLength != null &&
    maxFieldLength > 0 &&
    answer.length / writebackFieldAttributes.max_field_length > 0.5;
  const showWarn =
    showHint &&
    answer.length / writebackFieldAttributes.max_field_length > 0.75;

  const showNumberInput =
    data.writeback?.data_type === 'number' ||
    data.writeback?.data_type === 'currency';

  const showTextInput = maxFieldLength != null && maxFieldLength <= 50;

  return (
    <div className={css.textSurvey}>
      <p className={css.textSurveyText}>
        {data.question}
        {data.required && ' *'}
      </p>
      {currentError && (
        <p className={css.textSurveyError}>{currentError.message}</p>
      )}
      {fetching || !data ? (
        <Loading />
      ) : (
        <div className={css.textContainer}>
          <div className={css.textWrapper}>
            {showTextInput && (
              <input
                value={answer}
                placeholder={'Enter your answer here'}
                disabled={fetching}
                // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number | undefined'.
                maxLength={
                  maxFieldLength
                    ? writebackFieldAttributes?.max_field_length
                    : null
                }
                onChange={(e) => setAnswer(e.target.value)}
                className={classify(css.smallInput, {
                  [css.numberInput]: showNumberInput,
                })}
              />
            )}

            {showNumberInput && (
              <NumberInputNew
                className={classify(css.smallInput, css.numberInput)}
                value={answer}
                onChange={(val) => {
                  setAnswer(val);
                }}
                isFloat
                placeholder="Enter a number"
              />
            )}

            {!showTextInput && !showNumberInput && (
              <textarea
                value={answer}
                placeholder={'Enter your answer here'}
                disabled={fetching}
                // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number | undefined'.
                maxLength={
                  maxFieldLength
                    ? writebackFieldAttributes?.max_field_length
                    : null
                }
                onChange={(e) => setAnswer(e.target.value)}
              />
            )}
            <div className={css.hintTextContainer}>
              {showHint && (
                <p>
                  <span>{`${writebackFieldAttributes.max_field_length} characters or less `}</span>
                  <span
                    className={classify({
                      [css.hintText]: showWarn,
                    })}
                  >{` (${
                    writebackFieldAttributes.max_field_length - answer.length
                  }  remaining)`}</span>
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      <button
        className={css.submitButton}
        // @ts-expect-error - TS2322 - Type '(evt: Event) => void' is not assignable to type 'MouseEventHandler<HTMLButtonElement>'.
        onClick={(evt: Event) => {
          evt.preventDefault();
          handleNext(answer);
        }}
      >
        Submit
      </button>
      {buttonColor && (
        <style>{`
          .${buttonClass} {
            background-color: ${buttonColor};
            border-color: ${buttonColor};
          }
          .${buttonClass}:hover {color: ${buttonColor};}
        `}</style>
      )}
    </div>
  );
};
export default TextSurveyQuestion;

// Made with ♥️ by SpacedOut Labs

/**
 * shadeColor
 * http://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors

 Unused, commenting out for now
 */
// function shadeColor(color, percent) {
//   const f = parseInt(color.slice(1), 16),
//     t = percent < 0 ? 0 : 255,
//     p = percent < 0 ? percent * -1 : percent,
//     R = f >> 16,
//     G = (f >> 8) & 0x00ff,
//     B = f & 0x0000ff;
//   return `#${(
//     0x1000000 +
//     (Math.round((t - R) * p) + R) * 0x10000 +
//     (Math.round((t - G) * p) + G) * 0x100 +
//     (Math.round((t - B) * p) + B)
//   )
//     .toString(16)
//     .slice(1)}`;
// }
